import { render, staticRenderFns } from "./edit-meal-plan-form.vue?vue&type=template&id=25eef0da&"
import script from "./edit-meal-plan-form.vue?vue&type=script&lang=js&"
export * from "./edit-meal-plan-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFormLabel: require('@chakra-ui/vue').CFormLabel, CInput: require('@chakra-ui/vue').CInput, CImage: require('@chakra-ui/vue').CImage, CInputRightElement: require('@chakra-ui/vue').CInputRightElement, CInputGroup: require('@chakra-ui/vue').CInputGroup, CFormControl: require('@chakra-ui/vue').CFormControl, CSelect: require('@chakra-ui/vue').CSelect, CFlex: require('@chakra-ui/vue').CFlex, CText: require('@chakra-ui/vue').CText, CBox: require('@chakra-ui/vue').CBox})
